import { useEffect } from 'react';

export default function TawkChat() {
  useEffect(() => {
    if (document.getElementById('tawk-script')) return;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const script = document.createElement('script');
    script.id = 'tawk-script';
    script.async = true;
    script.src = 'https://embed.tawk.to/69b0f8cebe53e11c396ebe77/1jjdknqce';
    script.charset = 'UTF-8';
    // script.setAttribute('crossorigin', '*');

    document.body.appendChild(script);
  }, []);

  return null;
}